module.exports = __webpack_public_path__ + "img/icon-white-42.aa28a843.svg";